var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('p',{staticClass:"custom-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("body",function(){return [_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }